import { useEffect, useState } from 'react';

export const LoadingLogo = () => {
  const [show, setShow] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setShow(false), 2000);
    return () => clearTimeout(timer);
  }, []);

  if (!show) return null;

  return (
    <div className="fixed inset-0 z-[9999] bg-gradient-to-br from-brand-cyan via-brand-primary to-brand-magenta flex items-center justify-center animate-fadeIn">
      <div className="relative">
        {/* Animated circles behind logo */}
        <div className="absolute inset-0 -m-20">
          <div className="absolute inset-0 border-4 border-white/20 rounded-full animate-ping" />
          <div className="absolute inset-0 border-4 border-white/30 rounded-full animate-pulse animation-delay-100" />
          <div className="absolute inset-0 border-4 border-white/40 rounded-full animate-ping animation-delay-200" />
        </div>

        {/* Logo with animation */}
        <div className="relative animate-bounce">
          <img
            src="/aaa-logo.png"
            alt="AAAprinters"
            className="h-40 w-auto drop-shadow-2xl"
          />
        </div>

        {/* Loading text */}
        <div className="mt-8 text-center">
          <div className="flex items-center justify-center space-x-2">
            <div className="w-2 h-2 bg-white rounded-full animate-bounce" />
            <div className="w-2 h-2 bg-white rounded-full animate-bounce animation-delay-100" />
            <div className="w-2 h-2 bg-white rounded-full animate-bounce animation-delay-200" />
          </div>
        </div>
      </div>
    </div>
  );
};
